import React from 'react';
import Button from "react-bootstrap/Button";

const CreateButton = props => (
    <Button onClick={() => props.onClick} block={props.block}>
        <i className="fas fa-plus mr-2"/>{props.title}
    </Button>
)

export default CreateButton;